import React from "react";
import './conf.css';

function Conf() {
    return (
        <div>
                    <h1 className="text-center">CONFIDENTIALITY STATEMENT</h1>
                    <p className="text-center">At IndiaFilings, we place a major emphasis on maintaining confidentiality of Client information and Information Security Management. The following are key features of our Confidentiality Agreement, applicable to all our clients.</p>
                    <ul className="p-l-25" style={{ listStyle: 'lower-roman' }}>
                        <li>We do not disclose any information pertaining to our Clients to any third parties.</li>
                        <li>We do not use our Clients' identity or Clients' brand for our marketing purposes, without their written consent.</li>
                        <li>We never provide our Client's name or Client's information to other prospective clients for marketing purposes.</li>
                        <li>We do not sell or disclose our Client list or Client Information to third parties.</li>
                    </ul>
                    <div className="hr-title hr-long center"><abbr>CONFIDENTIALITY AGREEMENT</abbr></div>
                    <p className="text-center">It is understood and agreed to that an IndiaFilings Client may provide certain information that is and must be kept confidential. To ensure the protection of such information, and to preserve any confidentiality necessary under patent and/or trade secret laws, it is agreed that:</p>
                    <ul className="p-l-25 m-b-0" style={{ listStyle: 'decimal' }}>
                        {/* ... (rest of your code) */}
                    </ul>
                    </div>
                
    );
}

export default Conf;
